import type { ImageLoadData } from '@/map-phaser-new/interfaces'

type EventsShipImageLoadDataFunction = (eventAssetsDirectory: string) => ImageLoadData[]

export const eventsShipImageLoadData: EventsShipImageLoadDataFunction = (
  eventAssetsDirectory: string,
): ImageLoadData[] => [
  {
    name: 'buildings.event_ship',
    compressed: false,
    data: {
      astc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship-astc8.ktx?v2`,
      },
      etc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship-etc2rgba.ktx?v2`,
      },
      img: {
        textureURL: `events/${eventAssetsDirectory}/event-ship/event-ship.avif`,
      },
      place: `events/${eventAssetsDirectory}/event-ship/event-ship.avif`,
    },
  },
  {
    name: 'buildings.event_ship_outline',
    compressed: false,
    data: {
      astc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-astc8.ktx?v2`,
      },
      etc: {
        type: 'KTX',
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline-etc2rgba.ktx?v2`,
      },
      img: {
        textureURL: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline.avif`,
      },
      place: `events/${eventAssetsDirectory}/event-ship-outline/event-ship-outline.avif`,
    },
  },
]
